export class Store {
    constructor() {
        this.state = {
            loading: false,
            data: null,
            error: null,
            users: [],
            settings: {}
        };

        this.listeners = new Map();
    }

    setState(newState) {
        this.state = { ...this.state, ...newState };
        this.notify();
    }

    getState() {
        return this.state;
    }

    getValue(key) {
        return this.state[key];
    }

    subscribe(key, callback) {
        if (!this.listeners.has(key)) {
            this.listeners.set(key, new Set());
        }
        this.listeners.get(key).add(callback);
    }

    unsubscribe(key, callback) {
        if (this.listeners.has(key)) {
            this.listeners.get(key).delete(callback);
        }
    }

    notify() {
        for (const [key, callbacks] of this.listeners) {
            if (this.state[key] !== undefined) {
                callbacks.forEach(callback => callback(this.state[key]));
            }
        }
    }

    // Kullanıcı işlemleri
    async getUsers() {
        try {
            this.setState({ loading: true });
            // Örnek veri - gerçek uygulamada API'den gelecek
            const users = [
                {
                    id: 1,
                    name: 'Ahmet Yılmaz',
                    email: 'ahmet@example.com',
                    role: 'Admin',
                    status: 'active'
                },
                {
                    id: 2,
                    name: 'Mehmet Demir',
                    email: 'mehmet@example.com',
                    role: 'User',
                    status: 'inactive'
                }
            ];
            this.setState({ users, loading: false });
            return users;
        } catch (error) {
            this.setState({ error, loading: false });
            throw error;
        }
    }

    async createUser(userData) {
        try {
            this.setState({ loading: true });
            // Örnek implementasyon
            const newUser = {
                id: Date.now(),
                ...userData,
                status: 'active'
            };
            const users = [...this.state.users, newUser];
            this.setState({ users, loading: false });
            return newUser;
        } catch (error) {
            this.setState({ error, loading: false });
            throw error;
        }
    }

    async updateUser(userId, userData) {
        try {
            this.setState({ loading: true });
            const users = this.state.users.map(user =>
                user.id === userId ? { ...user, ...userData } : user
            );
            this.setState({ users, loading: false });
            return users.find(u => u.id === userId);
        } catch (error) {
            this.setState({ error, loading: false });
            throw error;
        }
    }

    async deleteUser(userId) {
        try {
            this.setState({ loading: true });
            const users = this.state.users.filter(user => user.id !== userId);
            this.setState({ users, loading: false });
            return true;
        } catch (error) {
            this.setState({ error, loading: false });
            throw error;
        }
    }

    // Ayarlar işlemleri
    async getSettings() {
        try {
            this.setState({ loading: true });
            // Örnek veri
            const settings = {
                companyName: 'Örnek Şirket',
                email: 'info@example.com',
                phone: '+90 555 123 4567',
                address: 'Örnek Mahallesi, Örnek Sokak No:1'
            };
            this.setState({ settings, loading: false });
            return settings;
        } catch (error) {
            this.setState({ error, loading: false });
            throw error;
        }
    }

    async updateSettings(newSettings) {
        try {
            this.setState({ loading: true });
            const settings = { ...this.state.settings, ...newSettings };
            this.setState({ settings, loading: false });
            return settings;
        } catch (error) {
            this.setState({ error, loading: false });
            throw error;
        }
    }
}